import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from '../navigation/navigation.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebfooterComponent } from '../webfooter/webfooter.component';
import { PopUpComponent } from '../pop-up/pop-up.component';


@NgModule({
  declarations: [
    NavigationComponent,
    HeaderComponent,
    WebfooterComponent,
    PopUpComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    NavigationComponent,
    HeaderComponent,
    RouterModule,
    CommonModule ,
    HeaderComponent,
    WebfooterComponent,
    PopUpComponent

  ]
})
export class SharedModule { 

}
